import { getLocalStorage, setLocalStorage } from './local-storage';

// Used to land on a specific element coming back from a login
export const analyticsFrom = {
  name: 'analyticsFrom',
  get: () => getLocalStorage(analyticsFrom.name),
  set: (value) => {
    setLocalStorage(analyticsFrom.name, value);
  },
  clean: () => {
    localStorage.removeItem(analyticsFrom.name);
  },
};
